import React from 'react';
import { bool, oneOfType, string, func } from 'prop-types';
import { POSDataProvider } from '@olxbr/mojo-jojo/providers';


function FooterItem({
  className, classLink, link, text, showExitPopup,
}) {
  const renderModalLink = () => (
    <span className={classLink || ''} onClick={() => showExitPopup(link)}>
      { text }
    </span>
  );

  const renderLink = () => (
    <a className={classLink} href={link}>
      { text }
    </a>
  );

  const renderChildren = (limitExceeded, standAlone) => {
    if (limitExceeded && !standAlone) {
      return renderModalLink();
    }

    if (classLink) {
      return renderLink();
    }

    return text;
  };

  return (
    <li className={className}>
      <POSDataProvider>
        {({ limitExceeded, standAlone }) => (
          renderChildren(limitExceeded, standAlone)
        )}
      </POSDataProvider>
    </li>
  );
}

FooterItem.propTypes = {
  className: string.isRequired,
  classLink: oneOfType([bool, string]),
  link: string.isRequired,
  text: string.isRequired,
  showExitPopup: func.isRequired,
};

FooterItem.defaultProps = {
  classLink: false,
};

export default FooterItem;
